import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import { api, fmtDate } from "@/lib/api";
import { PageHead, Stat, Panel } from "./AdminLayout";
import { StatusBadge } from "./Leads";

export default function Overview() {
  const [a, setA] = useState(null);
  const [leads, setLeads] = useState([]);
  useEffect(() => {
    api.get("/admin/analytics").then((r) => setA(r.data));
    api.get("/admin/leads").then((r) => setLeads(r.data.slice(0, 6)));
  }, []);
  if (!a) return <p className="font-mono text-sm text-slate-500">Memuat...</p>;
  return (
    <div data-testid="admin-overview">
      <PageHead eyebrow="Dashboard" title="Overview Operasional" desc="Ringkasan prospek, aktivitas AI Virtual Assistant, dan kondisi Knowledge Base." />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Total Lead" value={a.leads_total} testid="stat-leads-total" />
        <Stat label="Lead Baru" value={a.leads_new} accent="text-[#D97706]" testid="stat-leads-new" />
        <Stat label="Sesi Chatbot" value={a.total_sessions} testid="stat-sessions" />
        <Stat label="Eskalasi WA" value={`${a.escalated} · ${a.escalation_rate}%`} accent="text-emerald-600" testid="stat-escalations" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <Panel title="Sesi Chatbot 14 Hari Terakhir" className="lg:col-span-2">
          <div className="h-64">
            <ResponsiveContainer>
              <AreaChart data={a.daily}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="date" fontSize={11} /><YAxis allowDecimals={false} fontSize={11} /><Tooltip />
                <Area dataKey="sessions" stroke="#D97706" fill="#D97706" fillOpacity={0.15} strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <Panel title="Knowledge Base">
          <div className="space-y-4">
            <div className="flex justify-between text-sm"><span>Dokumen</span><b data-testid="overview-kb-docs">{a.kb_documents}</b></div>
            <div className="flex justify-between text-sm"><span>Chunk terindeks</span><b>{a.kb_chunks}</b></div>
            <div className="flex justify-between text-sm"><span>Pesan dijawab AI</span><b>{a.total_messages}</b></div>
            <div className="flex justify-between text-sm"><span>Pertanyaan off-topic ditolak</span><b className="text-rose-600">{a.off_topic}</b></div>
            <div className="flex justify-between text-sm"><span>Lead dari website / chatbot</span><b>{a.leads_by_source.website} / {a.leads_by_source.chatbot}</b></div>
            <Link to="/admin/knowledge-base" className="block bg-[#0F2B48] py-2 text-center text-xs font-bold text-white hover:bg-[#D97706]">Kelola Knowledge Base</Link>
          </div>
        </Panel>
      </div>
      <Panel title="Lead Terbaru" className="mt-6" action={<Link to="/admin/leads" className="text-xs font-semibold text-[#D97706]">Lihat semua →</Link>}>
        <div className="divide-y">
          {leads.map((l) => (
            <div key={l.id} className="flex flex-wrap items-center justify-between gap-2 py-3 text-sm">
              <div><p className="font-semibold">{l.name}</p><p className="text-xs text-slate-500">{l.service} · {l.source} · {fmtDate(l.created_at)}</p></div>
              <StatusBadge status={l.status} />
            </div>
          ))}
          {!leads.length && <p className="text-sm text-slate-500">Belum ada lead.</p>}
        </div>
      </Panel>
    </div>
  );
}
